export default "<p>\r\n  forgot-password works!\r\n</p>\r\n"